module.exports = __webpack_public_path__ + "img/placeholder.92c7b68a.png";